import { useState } from 'react';

var updateAt = function updateAt(index, updateFn, set) {
  return set(function (l) {
    var copy = l.slice(0);
    var item = copy[index];
    copy[index] = updateFn(item);
    return copy;
  });
};

var slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var toConsumableArray = function toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
};

var useArray = function useArray(initialList) {
  var _useState = useState(initialList),
      _useState2 = slicedToArray(_useState, 2),
      list = _useState2[0],
      set$$1 = _useState2[1];

  return [list, {
    set: set$$1,
    empty: function empty() {
      return set$$1([]);
    },
    replace: function replace(list) {
      return set$$1(list);
    },
    push: function push(item) {
      return set$$1(function (l) {
        return [].concat(toConsumableArray(l), [item]);
      });
    },
    updateAt: function updateAt$$1(index, updateFn) {
      return updateAt(index, updateFn, set$$1);
    },
    setAt: function setAt(index, value) {
      return set$$1(function (l) {
        return [].concat(toConsumableArray(l.slice(0, index)), [value], toConsumableArray(l.slice(index + 1)));
      });
    },
    removeAt: function removeAt(index) {
      return set$$1(function (l) {
        return [].concat(toConsumableArray(l.slice(0, index)), toConsumableArray(l.slice(index + 1)));
      });
    },
    filter: function filter(filterFn) {
      return set$$1(function (l) {
        return l.filter(filterFn);
      });
    },
    map: function map(mapFn) {
      return set$$1(function (l) {
        return [].concat(toConsumableArray(l)).map(mapFn);
      });
    },
    sort: function sort(sortFn) {
      return set$$1(function (l) {
        return [].concat(toConsumableArray(l)).sort(sortFn);
      });
    },
    reverse: function reverse() {
      return set$$1(function (l) {
        return [].concat(toConsumableArray(l)).reverse();
      });
    },
    mergeBefore: function mergeBefore(arr) {
      return set$$1(function (l) {
        return [].concat(toConsumableArray(arr)).concat([].concat(toConsumableArray(l)));
      });
    },
    mergeAfter: function mergeAfter(arr) {
      return set$$1(function (l) {
        return [].concat(toConsumableArray(l)).concat([].concat(toConsumableArray(arr)));
      });
    }
  }];
};

export default useArray;